import HelpHub from '../docs/HelpHub';

/** @deprecated route alias — single Help hub (Overview) */
export default function AboutKiponos() {
  return <HelpHub initialSection='overview' />;
}
